<template>
<div>
    <div class="vx-card pb-12">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Achats *</h4>
            </div>
        </div>

        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->
                <div class="w-full">
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/2 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Type *</label>

                                <div class="mt-2">
                                    <v-select class="w-full" v-model="infoFournissseur.typeAchat" :options="typeOptions" v-validate="'required'" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Logistique</h4>
            </div>
        </div>

        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->
                <div class="w-full">
                    <div class="flex mb-base mt-2 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Livraison</label>

                                <div class="mt-1 vx-row">
                                    <div class="mt-2">
                                        <vs-checkbox v-model="infoFournissseur.collecte">collecte</vs-checkbox>
                                    </div>
                                    <div class="mt-2">
                                        <vs-checkbox v-model="infoFournissseur.LivraisonFournisseur">Fournisseur</vs-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/4 lg:w-1/4 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Délai de Livraison</label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.delaiLivraison" icon-pack="feather" icon="icon-edit" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex mb-6 mt-4 vx-col md:w-full ">

                        <div class="w-full  ">
                            <h4 class=" ">Pièce Jointe :</h4>

                            <div class="mt-1   ">
                                <vs-upload limit="3" ref="upfilesref" @change="preview()" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import vSelect from "vue-select";
export default {
    props: {
        infoFournissseur: {
            type: Object
        }
    },
    data() {
        return {
            typeOptions: [{
                    id: "pharmaceutique",
                    label: "Pharmaceutique"
                },
                {
                    id: "parapharmaceutique/paramedical",
                    label: "Pharmaceutique / paramédical"
                },
                {
                    id: "PharmaceutiqueetParapharmaceutique",
                    label: "Pharmaceutique et Parapharmaceutique"
                }
            ],

        };
    },
    watch: {

    },
    computed: {

        headers() {
            return {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'Content-Type': 'multipart/form-data'
            }
        }
    },
    components: {
        vSelect
    },
    created() {

        this.$emit("updatePage", 3);
    },
    methods: {

        preview() {
            this.infoFournissseur.file1 = {
                filename: '',
                fileURL1: ''
            }
            this.infoFournissseur.file1.filename = this.$refs.upfilesref.filesx[0].name;
            this.infoFournissseur.file1.fileURL1 = this.$refs.upfilesref.filesx[0];
            if (this.$refs.upfilesref.filesx[1] != null) {
                console.log('file 2 ')
                this.infoFournissseur.file2 = {
                    filename: '',
                    fileURL2: ''
                }
                this.infoFournissseur.file2.filename = this.$refs.upfilesref.filesx[1].name;
                this.infoFournissseur.file2.fileURL2 = this.$refs.upfilesref.filesx[1];
            }
            if (this.$refs.upfilesref.filesx[2] != null) {
                console.log('file 3 ')
                this.infoFournissseur.file3 = {
                    filename: '',
                    fileURL3: ''
                }
                this.infoFournissseur.file3.filename = this.$refs.upfilesref.filesx[2].name;
                this.infoFournissseur.file3.fileURL3 = this.$refs.upfilesref.filesx[2];
            }
        },

    }
};
</script>

<style>
.upload-options {
    position: relative;
    height: 40px;
    width: 50%;
    background-color: #1B95E0;
    cursor: pointer;
    overflow: hidden;
    text-align: center;
    -webkit-transition: background-color ease-in-out 150ms;
    transition: background-color ease-in-out 150ms;
}

.upload-options input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.upload-options label {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-weight: 400;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
}
</style>
